import { render, staticRenderFns } from "./cbgc.vue?vue&type=template&id=6f70ed20&scoped=true&"
import script from "./cbgc.vue?vue&type=script&lang=js&"
export * from "./cbgc.vue?vue&type=script&lang=js&"
import style0 from "./cbgc.vue?vue&type=style&index=0&id=6f70ed20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70ed20",
  null
  
)

export default component.exports